import { Link, useLocation } from "react-router-dom";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CustomNestedTable from "../../common/CustomNestedTable";
import { useGetRestaurantHistory } from "../../../queryHooks/useSubscriptions";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../common/breadcrumbs";

const mData = {
	status: "success",
	message: "Successful",
	data: [
		{
			id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
			restaurant_id: "4ab7eac2-0efrb4a-4251-a2d8-47df576bbe2e",
			subscription_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
			stripe_subscription_id: "sub_1OD0jwHStiQQoaYRZCRIJk6m",
			status: "ACTIVE",
			next_billing_at: "2023-12-05T14:39:03.000Z",
			ended_at: null,
			created_at: "2023-11-16T08:16:00.000Z",
			updated_at: "2023-11-20T14:39:05.000Z",
			invoice_history: [
				{
					id: "13487ea3-875b-4e21-acd9-734412c4dfac",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OD0jwHStiQQoaYRbR9cZonV",
					billing_reason: "PURCHASE",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "11b0372e-5f55-422e-af6a-b2bcc74ec24f",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-16T08:36:02.000Z",
					transaction: {
						id: "11b0372e-5f55-422e-af6a-b2bcc74ec24f",
						payment_id: "pi_3OD0jxHStiQQoaYR02GjMUbf",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-16T08:36:02.000Z",
					},
				},
				{
					id: "2596ba5d-2877-4ee7-a552-d9ef7606920a",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1ODjh9HStiQQoaYReqDMMiDb",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "c0fea8d0-1db4-4212-8c38-4f452f41525c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-18T09:17:42.000Z",
					transaction: {
						id: "c0fea8d0-1db4-4212-8c38-4f452f41525c",
						payment_id: "pi_3ODkelHStiQQoaYR1uZLdqar",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-18T09:17:42.000Z",
					},
				},
				{
					id: "4e0619d4-29b5-44ca-af92-a63fb001b1f6",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OESf4HStiQQoaYR4A9wqwpt",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "a5155718-25af-4cb1-9808-5c22766008b2",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-20T09:22:54.000Z",
					transaction: {
						id: "a5155718-25af-4cb1-9808-5c22766008b2",
						payment_id: "pi_3OETgtHStiQQoaYR02KwJGcx",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T09:22:54.000Z",
					},
				},
				{
					id: "6ef1995b-d031-4896-a6e6-f38c136615ea",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OEYaoHStiQQoaYRlXyDBXqr",
					billing_reason: "CHANGE_PLAN",
					current_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "00771fdf-7128-4419-82d1-8ca781a0f9da",
					price: "2.01",
					tax: "0.00",
					net_amount: "2.01",
					created_at: "2023-11-20T14:36:57.000Z",
					transaction: {
						id: "00771fdf-7128-4419-82d1-8ca781a0f9da",
						payment_id: "pi_3OEYaoHStiQQoaYR0y7Sihu6",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T14:36:57.000Z",
					},
				},
				{
					id: "8e681cb7-9c7f-413d-ab4c-91263806e5be",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OE6BdHStiQQoaYRk3vC2okw",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "bf36b27b-97ed-48ff-bcec-2ff4fc04bf5c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-19T09:39:32.000Z",
					transaction: {
						id: "bf36b27b-97ed-48ff-bcec-2ff4fc04bf5c",
						payment_id: "pi_3OE7TRHStiQQoaYR16MWxCKJ",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-19T09:39:32.000Z",
					},
				},
				{
					id: "bec2dfa4-4667-4c02-ad94-4d9980473753",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OEY7JHStiQQoaYRUxTfFD86",
					billing_reason: "CHANGE_PLAN",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
					transaction_id: "5deb7e94-3172-4edc-a57f-1e98c83ed6e0",
					price: "0.91",
					tax: "0.00",
					net_amount: "0.91",
					created_at: "2023-11-20T14:06:28.000Z",
					transaction: {
						id: "5deb7e94-3172-4edc-a57f-1e98c83ed6e0",
						payment_id: "pi_3OEY7JHStiQQoaYR1vnlIfGz",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T14:06:28.000Z",
					},
				},
				{
					id: "d8a86cbd-bb4e-4be3-8614-160e33900ea0",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1ODNDkHStiQQoaYRHEL25WEL",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "3b36b2e6-9212-48ca-b759-c755277f533c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-17T09:16:59.000Z",
					transaction: {
						id: "3b36b2e6-9212-48ca-b759-c755277f533c",
						payment_id: "pi_3ODOAVHStiQQoaYR0jHS0g2w",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-17T09:16:59.000Z",
					},
				},
			],
		},

		{
			id: "27eee31b7cf-0796-42wd95-fe17e7cd7dfb",
			restaurant_id: "4ab7eac2-0b4a-4251-a2d8-47df576bbe2e",
			subscription_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
			stripe_subscription_id: "sub_1OD0jwHStiQQoaYRZCRIJk6m",
			status: "ACTIVE",
			next_billing_at: "2023-12-05T14:39:03.000Z",
			ended_at: null,
			created_at: "2023-11-16T08:16:00.000Z",
			updated_at: "2023-11-20T14:39:05.000Z",
			invoice_history: [
				{
					id: "13487ea3-875b-4e21-acd9-734412c4dfac",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OD0jwHStiQQoaYRbR9cZonV",
					billing_reason: "PURCHASE",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "11b0372e-5f55-422e-af6a-b2bcc74ec24f",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-16T08:36:02.000Z",
					transaction: {
						id: "11b0372e-5f55-422e-af6a-b2bcc74ec24f",
						payment_id: "pi_3OD0jxHStiQQoaYR02GjMUbf",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-16T08:36:02.000Z",
					},
				},
				{
					id: "2596ba5d-2877-4ee7-a552-d9ef7606920a",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1ODjh9HStiQQoaYReqDMMiDb",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "c0fea8d0-1db4-4212-8c38-4f452f41525c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-18T09:17:42.000Z",
					transaction: {
						id: "c0fea8d0-1db4-4212-8c38-4f452f41525c",
						payment_id: "pi_3ODkelHStiQQoaYR1uZLdqar",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-18T09:17:42.000Z",
					},
				},
				{
					id: "4e0619d4-29b5-44ca-af92-a63fb001b1f6",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OESf4HStiQQoaYR4A9wqwpt",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "a5155718-25af-4cb1-9808-5c22766008b2",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-20T09:22:54.000Z",
					transaction: {
						id: "a5155718-25af-4cb1-9808-5c22766008b2",
						payment_id: "pi_3OETgtHStiQQoaYR02KwJGcx",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T09:22:54.000Z",
					},
				},
				{
					id: "6ef1995b-d031-4896-a6e6-f38c136615ea",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OEYaoHStiQQoaYRlXyDBXqr",
					billing_reason: "New ",
					current_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "00771fdf-7128-4419-82d1-8ca781a0f9da",
					price: "2.01",
					tax: "0.00",
					net_amount: "2.01",
					created_at: "2023-11-20T14:36:57.000Z",
					transaction: {
						id: "00771fdf-7128-4419-82d1-8ca781a0f9da",
						payment_id: "pi_3OEYaoHStiQQoaYR0y7Sihu6",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T14:36:57.000Z",
					},
				},
				{
					id: "8e681cb7-9c7f-413d-ab4c-91263806e5be",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OE6BdHStiQQoaYRk3vC2okw",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "bf36b27b-97ed-48ff-bcec-2ff4fc04bf5c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-19T09:39:32.000Z",
					transaction: {
						id: "bf36b27b-97ed-48ff-bcec-2ff4fc04bf5c",
						payment_id: "pi_3OE7TRHStiQQoaYR16MWxCKJ",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-19T09:39:32.000Z",
					},
				},
				{
					id: "bec2dfa4-4667-4c02-ad94-4d9980473753",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1OEY7JHStiQQoaYRUxTfFD86",
					billing_reason: "CHANGE_PLAN",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "97e8ebda-e767-4eec-9c40-7350aeae8cf0",
					transaction_id: "5deb7e94-3172-4edc-a57f-1e98c83ed6e0",
					price: "0.91",
					tax: "0.00",
					net_amount: "0.91",
					created_at: "2023-11-20T14:06:28.000Z",
					transaction: {
						id: "5deb7e94-3172-4edc-a57f-1e98c83ed6e0",
						payment_id: "pi_3OEY7JHStiQQoaYR1vnlIfGz",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-20T14:06:28.000Z",
					},
				},
				{
					id: "d8a86cbd-bb4e-4be3-8614-160e33900ea0",
					subscription_id: "2731b7cf-0796-4295-8360-fe17e7cd7dfb",
					invoice_id: "in_1ODNDkHStiQQoaYRHEL25WEL",
					billing_reason: "RENEWAL",
					current_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					upcoming_plan_id: "797f1ee8-4a53-41ad-aee0-e8e4309203f4",
					transaction_id: "3b36b2e6-9212-48ca-b759-c755277f533c",
					price: "12.00",
					tax: "0.00",
					net_amount: "12.00",
					created_at: "2023-11-17T09:16:59.000Z",
					transaction: {
						id: "3b36b2e6-9212-48ca-b759-c755277f533c",
						payment_id: "pi_3ODOAVHStiQQoaYR0jHS0g2w",
						platform: "STRIPE",
						payment_type: 5,
						status: "",
						created_at: "2023-11-17T09:16:59.000Z",
					},
				},
			],
		},
	],
};

const SubscriptionsTable = () => {
	const location = useLocation();
	const [dataSource, setDataSource] = useState();
	const [id] = useState(location?.state?.restaurant_id);
	const {
		data,
		mutateAsync: getHistory,
		isLoading,
	} = useGetRestaurantHistory();
	const columns = [
		// {
		// 	title: "Subscription ID",
		// 	type: "string",
		// 	dataIndex: "id",
		// 	alias: "id",
		// },
		{
			title: "Subscription Plan",
			type: "string",
			dataIndex: "subscription_plan",
			alias: "subscription_plan",
			render: (item) => <p>{item.label}</p>,
		},
		{
			title: "Stripe Subscription ID",
			type: "string",
			dataIndex: "stripe_subscription",
			alias: "stripe_subscription",
			render: (item) => (
				<a href={item.url} target="_blank" rel="noreferrer">
					{item.id}
				</a>
			),
		},
		{
			title: "Status",
			type: "string",
			dataIndex: "status",
			aliasFilter: "status",
		},
		{
			title: "Created At",
			type: "string",
			dataIndex: "created_at",
			alias: "subscriptions.created_at",
			sort: true,
			render: (item) => (
				<div className="float-left">{getCurrentTimezoneDate(item)} </div>
			),
		},
		{
			title: "Next Billing At",
			type: "string",
			dataIndex: "next_billing_at",
			filterDate: true,
			alias: "next_billing_at",
			render: (item) => (
				<div className="float-left">{getCurrentTimezoneDate(item)} </div>
			),
		},
		{
			title: "Ended At",
			type: "string",
			dataIndex: "ended_at",
			alias: "ended_at",
			filterDate: true,
			render: (item) => <div className="float-left"> {item ?? "N/A"}</div>,
		},
	];

	const subColumns = [
		{
			title: "Strip Invoice ID",
			type: "string",
			dataIndex: "stripe_invoice",
			alias: "stripe_invoice",

			render: (item, _) => (
				<a href={item.url} target="_blank" rel="noreferrer">
					{_.invoice_id}
				</a>
			),
		},
		{
			title: "Billing Reason",
			type: "string",
			dataIndex: "billing_reason",
			alias: "billing_reason",
		},
		{
			title: "Current Plan",
			type: "string",
			dataIndex: "current_plan",
			aliasFilter: "current_plan",
			render: (item) => {
				return <p>{item.label}</p>;
			},
		},
		{
			title: "Upcoming Plan",
			type: "string",
			dataIndex: "upcoming_plan",
			aliasFilter: "upcoming_plan",
			render: (item) => {
				return <p>{item.label}</p>;
			},
		},
		{
			title: "Net Amount",
			type: "string",
			dataIndex: "net_amount",
		},
		{
			title: "Payment ID",
			type: "string",
			dataIndex: "transaction",
			alias: "transaction",
			render: (item) => (
				<a
					href={item?.stripe_payment_intent.url}
					target="_blank"
					rel="noreferrer"
				>
					{item.payment_id}
				</a>
			),
		},
		{
			title: "Payment Status",
			type: "string",
			dataIndex: "transaction",
			render: (item) => <p>{item.status} </p>,
		},
		{
			title: "Created At",
			type: "string",
			dataIndex: "created_at",
			render: (item) => (
				<div className="float-left">{getCurrentTimezoneDate(item)} </div>
			),
		},
	];

	useEffect(() => {
		if (id) getHistory(id);
	}, [id]);
	useEffect(() => {
		if (data) {
			let mockData = data?.data;

			mockData = mockData?.map((item) => {
				let res = {
					...item,
					key: item.restaurant_id,
					table: { data: item.invoice_history, columns: subColumns },
				};
				return res;
			});
			setDataSource(mockData);
		}
	}, [data]);
	return (
		<>
			<Breadcrumbs
				title="Subscriptions"
				className="mb-3"
				data={[{ label: "Restaurant Subscription History" }]}
			/>
			<CustomNestedTable
				isLoading={isLoading}
				data={dataSource}
				columns={columns}
			/>
		</>
	);
};

export default SubscriptionsTable;
